import {
  Typography,
  Grid,
  Card,
  Slider,
  Checkbox,
  Button,
  Input,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SavingsIcon from "@mui/icons-material/Savings";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { DeleteOutline } from "@mui/icons-material";
import styled from "styled-components";
import LockOpenIcon from "@mui/icons-material/LockOpen";

export const SAssetControls = styled(Grid)`
  && {
    height: 100%;
    width: 100%;
    margin: 0;
    margin-bottom: 24px;
    padding: 0;
    border: none;
    box-sizing: border-box;
    border-radius: 4px;
  }
`;

export const SCardWrapper = styled(Grid)`
  && {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    border: none;
    background-color: transparent;
    box-sizing: border-box;
    border-radius: 4px;
  }
`;

interface SCardPropTypes {
  $selected: boolean;
}

export const SCard = styled(Card)<SCardPropTypes>`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin: 0;
    padding: 0;
    padding-top: 14px;
    margin-bottom: ${({ $selected }) => ($selected ? "11px" : "24px")};
    box-shadow: none;
    border: 1px solid ${({ theme }) => theme.colors.cardBorder};
    background-color: ${({ theme, $selected }) =>
      $selected ? theme.colors.cardBgSelected : theme.colors.cardBg};
    box-sizing: border-box;
    border-radius: 4px;
  }
`;

export const SCardColumn1 = styled(Grid)`
  && {
    width: 46px;
    padding-left: 14px;
    padding-right: 8px;
    height: 100%;
    align-self: stretch;
  }
`;

export const SCardColumn2 = styled(Grid)`
  && {
    width: calc(100% - 46px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0;
    margin: 0;
    padding-right: 14px;
  }
`;

export const SCardRow1 = styled(Grid)`
  && {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 0;
    margin-bottom: 4px;
  }
`;

export const SCardRow2 = styled(Grid)`
  && {
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
    width: 100%;
  }
`;

export const SCardRow3 = styled(Grid)`
  && {
    margin: 0;
    padding: 0;
    margin-bottom: 4px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const SCardRow4 = styled(Grid)`
  && {
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const SCardRow5 = styled(Grid)`
  && {
    width: 100%;
  }
`;

export const SCardTitle = styled(Typography)`
  && {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.textDefault};
  }
`;

export const SCardSubTitle = styled(Typography)`
  && {
    width: 100%;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    text-transform: capitalize;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.textGray};
  }
`;

export const SCardLabelPercentage = styled(Typography)`
  && {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.textDefault};
  }
`;

export const SCardLabelAmount = styled(Typography)`
  && {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.textDefault};
  }
`;
interface SCardInputPercentagePropsType {
  $selected: boolean;
}

export const SCardInputPercentage = styled(
  Input
)<SCardInputPercentagePropsType>`
  && {
    width: 120px;
    height: 40px;
    margin: 0;
    padding: 0;
    padding-left: 16px;
    padding-right: 12px;
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    border: none;
    box-shadow: none;
    color: ${({ theme }) => theme.colors.textDefault || "black"};
    background-color: ${({ theme, $selected }) =>
      $selected ? theme.colors.cardBgSelected : theme.colors.bgGray || "gray"};

    &:focus {
      outline: none !important;
      outline-offset: none !important;
    }

    input:hover {
      cursor: "default";
    }
    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 30px
        ${({ theme }) => theme.colors.bgGray || "gray"} inset;
    }
    border-radius: 2px;
    z-index: 999;
  }
`;

interface SCardInputAmountPropsType {
  $selected: boolean;
}

export const SCardInputAmount = styled(Input)<SCardInputAmountPropsType>`
  && {
    width: 120px;
    height: 40px;
    margin: 0;
    padding: 0;
    padding-left: 12px;
    padding-right: 12px;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    border: none;
    box-shadow: none;
    color: ${({ theme }) => theme.colors.textDefault || "black"};
    background-color: ${({ theme, $selected }) =>
      $selected ? theme.colors.cardBgSelected : theme.colors.bgGray || "gray"};

    &:focus {
      outline: none !important;
      outline-offset: none !important;
    }

    input:hover {
      cursor: "default";
    }
    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 30px
        ${({ theme }) => theme.colors.bgGray || "gray"} inset;
    }
    border-radius: 2px;
    z-index: 999;
  }
`;

export const SCardPercentageSlider = styled(Slider)`
  && {
    color: ${({ theme }) => theme.colors.addButtonPrimary};
    width: 100%;
  }
`;

export const SCardHomeIcon = styled(HomeIcon)`
  && {
    color: white;
    background-color: ${({ theme }) => theme.colors.funds};
    border-radius: 4px;
  }
`;

export const SCardHogIcon = styled(SavingsIcon)`
  && {
    color: white;
    background-color: ${({ theme }) => theme.colors.fixedIncome};
    border-radius: 4px;
  }
`;

export const SCardBuildIcon = styled(AccountBalanceIcon)`
  && {
    color: white;
    background-color: ${({ theme }) => theme.colors.pension};
    border-radius: 4px;
  }
`;

export const SCardBagIcon = styled(BusinessCenterIcon)`
  && {
    color: white;
    background-color: ${({ theme }) => theme.colors.stocks};
    border-radius: 4px;
  }
`;

export const SCardCheckBox = styled(Checkbox)`
  && {
    width: 24px;
    height: 24px;
    align-self: flex-start;
    margin: 0;
    padding: 0;
    margin-left: 10px;
    color: ${({ theme, checked }) =>
      checked
        ? theme.colors.cardCheckboxChecked
        : theme.colors.cardCheckboxUnchecked};
  }
`;

export const SDeleteButton = styled(Button)`
  && {
    margin: 0;
    padding: 0;
    width: 85px;
    height: 36px;
    border-radius: 4px;
    padding: 0px 8px;
    margin-right: 8px;
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.textDefault};
    background-color: ${({ theme }) => theme.colors.cardBgSelected};

    &:hover {
      background-color: ${({ theme }) => theme.colors.cardBgSelected};
    }
  }
`;

export const STrashCanIcon = styled(DeleteOutline)`
  && {
    font-size: 18px;
    line-height: 18px;
    margin-right: 2px;
  }
`;

export const SLockButton = styled(Button)`
  && {
    margin: 0;
    padding: 0;
    min-width: 85px;
    height: 36px;
    border-radius: 4px;
    padding: 0px 6px;
    margin-right: 8px;
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.textDefault};
    background-color: ${({ theme }) => theme.colors.cardBgSelected};

    &:hover {
      background-color: ${({ theme }) => theme.colors.cardBgSelected};
    }
  }
`;

export const SLockIcon = styled(LockOpenIcon)`
  && {
    font-size: 15px;
    line-height: 15px;
    margin: 0;
    margin-right: 2px;
    padding: 0;
  }
`;
